import { z } from 'zod';

export const languageAndCountryCodeSchema = z.object({
    languageCode: z.string(),
    language: z.string().optional(),
    countryCode: z.string().optional(),
    country: z.string().optional().nullable(),
    text: z.string(),
    value: z.string()
});

export type LanguageAndCountryCode = z.infer<typeof languageAndCountryCodeSchema>;
